  $(document).ready(function() {
  jQuery('.click-function').on('click', function() {
      if (jQuery(this).hasClass('active')){
        jQuery(this).removeClass('active');
      }else{
        jQuery(this).addClass('active');
      }
    });
    $(".novetty_caret").click(function(){
      if ($(this).parent().parent().parent().find(".widget-content").is(":hidden")) {
        $(this).parent().parent().parent().find(".widget-content").slideDown(300);
        $(this).find('i').removeClass('fa-caret-right');
        $(this).find('i').addClass('fa-caret-down');      
      } else {
        $(this).parent().parent().parent().find(".widget-content").slideUp(300);
        $(this).find('i').removeClass('fa-caret-down');
        $(this).find('i').addClass('fa-caret-right');
      }
    });
    // Event listener for currency selection
        $('.currency').on('click', function() {
        var selectedCurrency = $(this).data('currency'); // Get the data-currency value
        setCookie('currency', selectedCurrency, 7, 'monsieurblonde.com'); // Set the cookie with domain
    });

// Function to set a cookie with domain
function setCookie(name, value, days, domain) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // Adding domain with a leading dot to the cookie if provided
    var domainPart = domain ? "; domain=." + domain : "";
    document.cookie = name + "=" + (value || "") + expires + domainPart + "; path=/";
}
  });

